import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { WorkOrderService } from "../../../services/index";
import { cuttingPlanPrint } from "./cuttingPlanPrint";

declare var google;

@Component({
  selector: "cutting-plan",
  templateUrl: "cuttingPlan.html",
})
export class cuttingPlan implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoading: boolean = false;
  isLoadMask: Promise<any>;
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  saveEvent: any;
  selected = [];
  data = [];
  selectedCpNo = [];
  min_cuno: any;
  filter = {
    ff_cp_no: "",
    groupby: "ff_cp_no",
    from_date: "",
    to_date: "",
    status: "C.P NOT PROCESSED",
    ff_date: "",
  };
  statusList = ["C.P PROCESSED", "C.P NOT PROCESSED", "BOTH"];
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "wo.ff_cp_no",
    orderDir: "desc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("approveTemplate") approveTemplate;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;

  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private woservice: WorkOrderService,
    public toasterService: ToasterService,
    private modalService: BsModalService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {
    if (this.filter.groupby == "wo_id") {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Wo.no",
          prop: "wo_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Wo.Date",
          prop: "work_date",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
        {
          name: "Dc.no",
          prop: "dc_no",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Fab Design",
          prop: "fab_design",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Shirt DNo",
          prop: "shirt_design_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Cutting ratio",
          prop: "cutting_ratio",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "No.of.Color",
          prop: "no_of_colors",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "No.of.Pcs",
          prop: "tot_lumps",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Width",
          prop: "width",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Fab.Style",
          prop: "fab_style",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Fab.type",
          prop: "fab_type",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Shirt.style",
          prop: "style",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.Mtrs",
          prop: "tot_mtrs",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },

        {
          name: "Brand",
          prop: "brand",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Approve Status",
          prop: "approvedStatus",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
      ];
    } else {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "C.P No",
          prop: "ff_cp_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "FF.Date",
          prop: "ff_date",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },

        {
          name: "Cutting ratio",
          prop: "cutting_ratio",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "No.of.Pcs",
          prop: "tot_lumps",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Width",
          prop: "width",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Fab.Style",
          prop: "fab_style",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Fab.type",
          prop: "fab_type",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Shirt.style",
          prop: "style",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.Mtrs",
          prop: "tot_mtrs",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },

        {
          name: "Brand",
          prop: "brand",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 120,
          width: 110,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
        // {
        //   name: "Approve",
        //   prop: "sno",
        //   minWidth: 80,
        //   maxWidth: 120,
        //   width: 80,
        //   sortable: false,
        //   cellTemplate: this.approveTemplate,
        // },
      ];
      if (this.filter.status == "C.P NOT PROCESSED") {
        let select = {
          prop: "selected",
          name: "",
          sortable: false,
          canAutoResize: false,
          draggable: false,
          resizable: false,
          headerCheckboxable: true,
          checkboxable: true,
          width: 30,
        };
        this.columns.splice(0, 0, select);
      } else {
        let column = this.columns.filter(function (obj) {
          return obj.prop !== "selected";
        });
        this.columns = column;
      }
      if (this.filter.status == "C.P PROCESSED") {
        let cu_no = {
          name: "Cu.No",
          prop: "cu_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        };

        this.columns.splice(1, 0, cu_no);
      } else {
        let column = this.columns.filter(function (obj) {
          return obj.prop !== "cu_no";
        });
        this.columns = column;
      }
    }

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getOrderList();
  }

  clearFilter(): void {
    this.filter = {
      ff_cp_no: "",
      from_date: "",
      to_date: "",
      groupby: "ff_cp_no",
      status: "C.P NOT PROCESSED",
      ff_date: "",
    };
    this.applyFilter();
  }

  applyFilter(): void {
    this.getColumns();
  }
  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

    console.log(this.selected);
    let min = [];
    min = Math.min.apply(
      null,
      this.selected.map(function (item) {
        return item.cu_no;
      })
    );

    this.min_cuno = min;
    console.log(this.min_cuno);
  }
  viewFabFacStoreWo(row) {
    this.filter.ff_cp_no = row.ff_cp_no;
    this.filter.ff_date = row.ff_date;
    this.filter.groupby = "wo_id";
    this.getColumns();
  }
  gobacktoCpGroup() {
    this.filter.ff_cp_no = "";
    this.filter.ff_date = "";
    this.filter.groupby = "ff_cp_no";
    this.getColumns();
  }
  getOrderList(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    let params = {
      start: `${this.page.offset * this.page.limit}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
    };

    params["filter"] = JSON.stringify(this.filter);
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.woservice
      .getFabFacStoreWo(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
      });
  }
  onSubmitMergeCu() {
    if (this.selected.length > 0) {
      let obj = {
        ff_date: "",
        ff_cp_no: "",
      };
      this.selected.forEach((el) => {
        obj = {
          ff_date: el.ff_date,
          ff_cp_no: el.ff_cp_no,
        };
        this.data.push(obj);
      });
      this.approveCuttingPlan();
      // let that = this;
      // swal({
      //   title: "Are you sure to move these Cp.no(s) with same CU.NO?",
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonText: "Yes, Move it!",
      //   cancelButtonText: "No, want to change",
      // }).then(function () {
      //   let params = {
      //     selectedCuNo: JSON.stringify(that.min_cuno),
      //     cpdata: JSON.stringify(that.data),
      //   };
      //   that.isLoading = true;
      //   that.loadingIndicator = true;
      //   that.isLoadMask = that.woservice
      //     .moveToMergedCutting(params)
      //     .then(function (res: any) {
      //       that.loadingIndicator = false;
      //       that.isLoading = false;

      //       if (res.success) {
      //         that.selected = [];
      //         that.data = [];
      //         let tabObj = {
      //           action: "CloseTab",
      //           params: {},
      //         };
      //         that.tabUpdateEvent.emit(tabObj);
      //         //  that. getOrderList();
      //       }
      //     });
      // });
    } else {
      swal("Select Atleast One CU.NO");
    }
  }
  approveCuttingPlan() {
    let that = this;
    swal({
      title: "Are you sure to Approve these CP.NO with same Cutting Plan no?",
      html:
        '<input type = "text" id="approver" class="swal2-input" placeholder = "APPROVER">',
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "Cancel",
    }).then(
      function () {
        if (
          (<HTMLInputElement>document.getElementById("approver")).value != ""
        ) {
          let params = {
            selectedList: JSON.stringify(that.data),
            approver: (<HTMLInputElement>document.getElementById("approver"))
              .value,
          };
          that.isLoadMask = that.woservice
            .approveCuttingPlan(params)
            .then((res: any) => {
              if (res.success) {
                swal(
                  "C.P Approved Successfully and C.U No " +
                    res.cu_no +
                    " was generated"
                );
                setTimeout(() => {
                  swal({
                    title: "Do you need a print for C.U NO " + res.cu_no + "?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Print!",
                    cancelButtonText: "No",
                  })
                    .then(() => {
                      that.print(res);
                    })
                    .catch(() => {
                      let tabObj = {
                        action: "CloseTab",
                        params: {},
                      };
                      that.tabUpdateEvent.emit(tabObj);
                      tabObj = {
                        action: "NewTab",
                        params: {
                          //  tabParent: 'Transaction',
                          tabName: "CUTTING PLAN",
                          title: "CUTTING PLAN",
                          tabParent: "WORK ORDERS",
                          name: "CUTTING PLAN",
                        },
                      };
                      that.tabUpdateEvent.emit(tabObj);
                    });
                }, 2000);

                that.getOrderList();
              }
            });
        } else {
          swal("PLEASE ENTER APPROVER NAME");
        }
      },
      function (dismiss) {}
    );
  }
  bsModalRef: BsModalRef;
  print(res) {
    this.bsModalRef = this.modalService.show(cuttingPlanPrint, {
      keyboard: false,
      ignoreBackdropClick: true,
      class: "modal-lg compWidth-96",
    });
    this.bsModalRef.content.printdt = Object.assign({}, res);
    let tabObj = {
      action: "CloseTab",
      params: {},
    };
    this.tabUpdateEvent.emit(tabObj);
    tabObj = {
      action: "NewTab",
      params: {
        //  tabParent: 'Transaction',
        tabName: "CUTTING PLAN",
        title: "CUTTING PLAN",
        tabParent: "WORK ORDERS",
        name: "CUTTING PLAN",
      },
    };
    this.tabUpdateEvent.emit(tabObj);
    // this.bsModalRef.content.printcontent = this.printData;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/workorder/cuttingPlan.ts